import { Stack, Button, Theme, Box, IconButton, Menu, MenuItem, Divider, Link } from "@mui/material"
import React from "react"

import MenuIcon from '@mui/icons-material/Menu';
import { tSplash } from "locales/splash/cruxTranslation";

interface Props {
  theme: Theme
  mobile: boolean;
}

enum Paths {
  Climbers = "/climbers",
  Gyms = "/",
  HomeWalls = "/homewalls",
  Contact = "/contact",
  Docs = "https://docs.cruxapp.ca/"
}

export function NavigationBar(props: Props) {
  const theme = props.theme;

  const currentPath = window.location.pathname;

  // Check if path matches pattern /XX/ or /XX/path where XX is 2 letter locale
  const isGymsSelected = /\/[a-zA-Z]{2}\/?$/.test(currentPath);
  const isClimbersSelected = /\/[a-zA-Z]{2}\/climbers\/?$/.test(currentPath);
  const isHomewallsSelected = /\/[a-zA-Z]{2}\/homewalls\/?$/.test(currentPath);
  const isContactSelected = /\/[a-zA-Z]{2}\/contact\/?$/.test(currentPath);

  // Also check non-localized paths
  const isGymsSelectedNoLocale = currentPath === Paths.Gyms;
  const isClimbersSelectedNoLocale = currentPath === Paths.Climbers;
  const isHomewallsSelectedNoLocale = currentPath === Paths.HomeWalls;
  const isContactSelectedNoLocale = currentPath === Paths.Contact;

  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const mobileMenuAnchorEl = React.useRef(null);

  if (props.mobile) {
    return (
      <Stack direction="row" justifyContent="start" sx={{
        padding: 2,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        boxSizing: "border-box",
      }}>
        {/* Hamburger */}
        <IconButton
          size="large"
          ref={mobileMenuAnchorEl}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <MenuIcon />
        </IconButton>
        {/* Menu */}
        <Menu
          open={mobileMenuOpen}
          anchorEl={mobileMenuAnchorEl.current}
          onClose={() => setMobileMenuOpen(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Link href={Paths.Gyms} color="inherit" underline="none">
            <MenuItem
              selected={isGymsSelected || isGymsSelectedNoLocale}
            >
              {tSplash("common.nav.commercial")}
            </MenuItem>
          </Link>
          <Link href={Paths.Climbers} color="inherit" underline="none">
            <MenuItem
              selected={isClimbersSelected || isClimbersSelectedNoLocale}
            >
              {tSplash("common.nav.climbers")}
            </MenuItem>
          </Link>
          <Link href={Paths.HomeWalls} color="inherit" underline="none">
            <MenuItem
              selected={isHomewallsSelected || isHomewallsSelectedNoLocale}
            >
              {tSplash("common.nav.homewalls")}
            </MenuItem>
          </Link>
          <Divider sx={{ mb: 1 }} />
          <Link href={Paths.Docs} color="inherit" underline="none" target="_blank">
            <MenuItem
              selected={false}
            >
              {tSplash("common.nav.docs")}
            </MenuItem>
          </Link>
          <Link href={Paths.Contact} color="inherit" underline="none">
            <MenuItem
              selected={isContactSelected || isContactSelectedNoLocale}
              onClick={() => window.location.href = Paths.Contact}
            >
              {tSplash("common.nav.contact")}
            </MenuItem>
          </Link>
        </Menu>
      </Stack>
    )
  } else {
    const activeButtonStyle = {
      textDecoration: "underline",
      textDecorationColor: theme.palette.primary.main,
      textDecorationThickness: "3px",
      textUnderlineOffset: "6px",
    };

    return (
      <Stack
        direction="row"
        spacing={3}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          padding: theme.spacing(3),
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Link href={Paths.Gyms} color="inherit" underline="none">
          <Button
            variant="text"
            color="primary"
            style={isGymsSelected || isGymsSelectedNoLocale ? activeButtonStyle : {}}
          >
            {tSplash("common.nav.commercial")}
          </Button>
        </Link>
        <Link href={Paths.Climbers} color="inherit" underline="none">
          <Button
            variant="text"
            color="primary"
            style={isClimbersSelected || isClimbersSelectedNoLocale ? activeButtonStyle : {}}
          >
            {tSplash("common.nav.climbers")}
          </Button>
        </Link>
        <Link href={Paths.HomeWalls} color="inherit" underline="none">
          <Button
            variant="text"
            color="primary"
            style={isHomewallsSelected || isHomewallsSelectedNoLocale ? activeButtonStyle : {}}
          >
            {tSplash("common.nav.homewalls")}
          </Button>
        </Link>
        <Box flexGrow={1} />
        <Link href={Paths.Docs} color="inherit" underline="none" target="_blank">
          <Button
            variant="text"
            color="primary"
          >
            {tSplash("common.nav.docs")}
          </Button>
        </Link>
        <Link href={Paths.Contact} color="inherit" underline="none">
          <Button
            variant="text"
            color="primary"
            style={isContactSelected || isContactSelectedNoLocale ? activeButtonStyle : {}}
          >
            {tSplash("common.nav.contact")}
          </Button>
        </Link>
      </Stack>
    );
  }


}
